export default {
    list: []
};
